"use client";

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

export default function CtaBanner() {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="bg-[#212529] text-white w-full">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative flex items-center justify-center h-16">
          <div className="flex items-center space-x-4">
            <div className="relative flex h-3 w-3">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
            </div>
            <p className="text-sm font-medium text-gray-300 hidden sm:block">
              Looking for a new Squarespace website?
            </p>
            <p className="text-sm font-medium text-gray-300 sm:hidden">
              New Squarespace site?
            </p>
          </div>
          <Button
            variant="secondary"
            className="bg-gray-700 hover:bg-gray-600 text-white rounded-full px-4 py-2 text-sm h-auto ml-4"
          >
            Get in touch now
          </Button>
          <Button
            variant="ghost"
            size="icon"
            className="text-gray-400 hover:text-white hover:bg-transparent absolute right-0 top-1/2 -translate-y-1/2"
            onClick={() => setIsVisible(false)}
          >
            <X className="h-5 w-5" />
            <span className="sr-only">Close banner</span>
          </Button>
        </div>
      </div>
    </div>
  );
}
